var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    { staticClass: "q-mb-md" },
    [
      _c(
        "q-collapsible",
        {
          attrs: { icon: "fal fa-filter", label: _vm.getNameFilter },
          on: { click: _vm.toggle },
          model: {
            value: _vm.open,
            callback: function($$v) {
              _vm.open = $$v
            },
            expression: "open"
          }
        },
        [
          _vm.options
            ? _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c(
                      "q-chips-input",
                      {
                        attrs: { "float-label": _vm.$t("requester") },
                        on: { remove: _vm.removeRequester },
                        model: {
                          value: _vm.filters.requester_names,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "requester_names", $$v)
                          },
                          expression: "filters.requester_names"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: {
                            debounce: 500,
                            "min-characters": 3,
                            "max-results": 30,
                            "value-field": function(v) {
                              return v.full_name + " - " + v.email
                            }
                          },
                          on: {
                            search: _vm.searchRequester,
                            selected: _vm.selectRequester
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c(
                      "q-chips-input",
                      {
                        attrs: { "float-label": _vm.$t("instructors") },
                        on: { remove: _vm.removeInstructor },
                        model: {
                          value: _vm.filters.instructor_names,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "instructor_names", $$v)
                          },
                          expression: "filters.instructor_names"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: {
                            debounce: 500,
                            "min-characters": 3,
                            "max-results": 30,
                            "value-field": function(v) {
                              return v.full_name + " - " + v.email
                            }
                          },
                          on: {
                            search: _vm.searchInstructor,
                            selected: _vm.selectInstructor
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c(
                      "q-input",
                      {
                        attrs: {
                          "float-label": _vm.$t("location_name"),
                          autocomplete: "new-password",
                          clearable: ""
                        },
                        on: { clear: _vm.removeBranch },
                        model: {
                          value: _vm.filters.company_branch_name,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "company_branch_name", $$v)
                          },
                          expression: "filters.company_branch_name"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: {
                            debounce: 500,
                            "min-characters": 3,
                            "max-results": 30,
                            "value-field": function(e) {
                              return (
                                e.document +
                                " " +
                                e.fantasy +
                                " - " +
                                e.address.address +
                                (e.address.number
                                  ? ", " + e.address.number
                                  : "") +
                                " - " +
                                e.address.city +
                                "/" +
                                e.address.state
                              )
                            },
                            separator: ""
                          },
                          on: {
                            search: _vm.searchBranch,
                            selected: _vm.selectBranch
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.options.appointment_types
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            chips: "",
                            multiple: "",
                            options: _vm.options.appointment_types,
                            "float-label": _vm.$t("appointment_type"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.filters.appointment_type,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "appointment_type", $$v)
                            },
                            expression: "filters.appointment_type"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.options.statuses
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            chips: "",
                            multiple: "",
                            options: _vm.options.statuses,
                            "float-label": _vm.$t("status"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.filters.status,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "status", $$v)
                            },
                            expression: "filters.status"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 gutter" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        "float-label": _vm.$t("creation_date_from"),
                        type: "datetime",
                        format: "DD/MM/YYYY HH:mm",
                        clearable: ""
                      },
                      model: {
                        value: _vm.filters.start_date_display,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "start_date_display", $$v)
                        },
                        expression: "filters.start_date_display"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 gutter" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        "float-label": _vm.$t("creation_date_to"),
                        type: "datetime",
                        format: "DD/MM/YYYY HH:mm",
                        clearable: ""
                      },
                      model: {
                        value: _vm.filters.end_date_display,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "end_date_display", $$v)
                        },
                        expression: "filters.end_date_display"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 gutter" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        "float-label": _vm.$t("event_date_from"),
                        type: "datetime",
                        format: "DD/MM/YYYY HH:mm",
                        clearable: ""
                      },
                      model: {
                        value: _vm.filters.event_start_date_display,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "event_start_date_display", $$v)
                        },
                        expression: "filters.event_start_date_display"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 gutter" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        "float-label": _vm.$t("event_date_to"),
                        type: "datetime",
                        format: "DD/MM/YYYY HH:mm",
                        clearable: ""
                      },
                      model: {
                        value: _vm.filters.event_end_date_display,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "event_end_date_display", $$v)
                        },
                        expression: "filters.event_end_date_display"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _c("div", { staticClass: "row gutter-sm justify-end q-mt-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "negative",
                    label: _vm.$t("clear_filters"),
                    icon: "far fa-eraser"
                  },
                  on: {
                    click: function($event) {
                      return _vm.clearFilter()
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    label: _vm.$t("apply_filter_plural"),
                    icon: "far fa-filter"
                  },
                  on: {
                    click: function($event) {
                      return _vm.requestFiltered()
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }